<template>
  <main class="m-content">
    <!-- <div class="bgImage">
    </div> -->
    <slot></slot>
  </main>
</template>

<script lang="ts">
export default {
  name: 'MContent'
}
</script>

<style lang="scss" scoped>
@include b(m-content) {
  overflow: auto;
  flex: 1;
  position: relative;
}
.bgImage {
  background-image: url('https://meta-oss.evkland.cn/scene/map/pc_gradient_bgi-1749266557664.png');
  background-size: 100% 30%; /* 宽度100%，高度30% */
  background-position: center top; /* 背景图片居中且靠顶部 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  position: absolute; /* 绝对定位 */
  top: 0;
  left: 0;
  height: 30vh;
  width: 100vh;
  z-index: 1; /* 确保背景图片在底层 */
}
</style>
